import {HoistService, XH} from '@xh/hoist/core';
import {getDefaultOptions} from '../../core/ServiceUtils';
import {Company, Security} from '../data/DataTypes';

export class SecMasterService extends HoistService {
    async fetchSecurityByIdAsync(id: number): Promise<Security> {
        return XH.fetchService.fetchJson({
            url: `${XH.getConf('svcApiUrl')}/secmaster/${id}`,
            method: 'GET',
            ...getDefaultOptions()
        });
    }

    async fetchSecurityCompanyByIdAsync(id: number): Promise<Company> {
        return XH.fetchService.fetchJson({
            url: `${XH.getConf('svcApiUrl')}/secmaster/${id}/company`,
            method: 'GET',
            ...getDefaultOptions()
        });
    }

    async getSecurityByTickerAsync(ticker: string): Promise<Security> {
        return XH.fetchService.fetchJson({
            url: `${XH.getConf('svcApiUrl')}/secmaster/byticker`,
            params: {ticker: ticker},
            method: 'GET',
            ...getDefaultOptions()
        });
    }

    async searchSecuritiesAsync(searchString: string, maxResults?: number): Promise<Security[]> {
        return XH.fetchService.fetchJson({
            url: `${XH.getConf('svcApiUrl')}/secmaster/search`,
            params: {searchString, count: maxResults},
            method: 'GET',
            ...getDefaultOptions()
        });
    }

    async searchSecurityUniverseAsync(searchString: string): Promise<Security[]> {
        return XH.fetchService.fetchJson({
            url: `${XH.getConf('svcApiUrl')}/secmaster/searchUniverse`,
            params: {searchString},
            method: 'GET',
            ...getDefaultOptions()
        });
    }

    async refreshSecurityAsync(id: number): Promise<Security> {
        return XH.fetchService.postJson({
            url: `${XH.getConf('svcApiUrl')}/secmaster/${id}/refresh`,
            ...getDefaultOptions()
        });
    }

    async importSecurityAsync(secStub: Security): Promise<Security> {
        return XH.fetchService.postJson({
            url: `${XH.getConf('svcApiUrl')}/secmaster/import`,
            body: secStub,
            ...getDefaultOptions()
        });
    }

    async deleteSecurityAsync(id: number): Promise<void> {
        return XH.fetchService.deleteJson({
            url: `${XH.getConf('svcApiUrl')}/secmaster/${id}`,
            ...getDefaultOptions()
        });
    }

    async saveSecurityAsync(security: Security): Promise<Security> {
        return XH.fetchService.postJson({
            url: `${XH.getConf('svcApiUrl')}/secmaster`,
            body: security,
            ...getDefaultOptions()
        });
    }

    async saveCompanyAsync(company: Company): Promise<Company> {
        return XH.fetchService.postJson({
            url: `${XH.getConf('svcApiUrl')}/secmaster/company`,
            body: company,
            ...getDefaultOptions()
        });
    }
}
